module.exports = __webpack_public_path__ + "src/assets/img/car_track_off.2159feca.svg";